export class StyleLoaderService {
  public loadStyle(styleUrl: string): Promise<boolean> {
    return new Promise((resolve, reject) => {
      const $style = document.createElement('link');
      $style.setAttribute('rel', 'stylesheet');
      $style.setAttribute('href', styleUrl);
      $style.onload = () => resolve(true);
      $style.onerror = () => reject();
      document.head.appendChild($style);
    });
  }
}
